<!--
 * @Author: qhy
 * @Date: 2022-05-19 14:54:00
 * @LastEditors: qhy
 * @LastEditTime: 2023-08-02 15:40:07
 * @Description: 搜索的功能，包括经纬度搜索和地名搜索
-->
<template>
    <div>
        <a-input v-if="pointUnit=='度分秒'" :class="`searchBar ${/dashboard\/analysis/.test(pageHref)&&!$parent.allScreen?'homeStyle':''}`" placeholder="查地点、经纬度" v-model="keyword" allowClear>
            <a-tooltip placement="bottom" slot="suffix" title="例：125,44 逗号分隔">
              <a-icon type="info-circle"/>
            </a-tooltip>
        </a-input>
        <!-- <a :class="`dfmBtn ${/dashboard\/analysis/.test(pageHref)&&!$parent.allScreen?'homeBtnStyle':''}`" v-if="pointUnit=='度分秒'" @click="pointUnit='十进制'"><a-icon type="swap" />度分秒</a> -->
        <div title="切换成度分秒" v-if="pointUnit=='度分秒'" @click="pointUnit='十进制'" class="dfmBtnDiv"><img src="~@/assets/RSsserviceManage/切换.png"></div>
        
        <div v-if="pointUnit=='十进制'" :class="`${/dashboard\/analysis/.test(pageHref)&&!$parent.allScreen?'homeStyle':''} dfmAllDiv`">
            <div style="width:43%;height:32px;display:flex;align-items: center;justify-content: center;">
                <div style="width:100%;height:100%;border:1px solid #a4a4a4;border-radius:6px;display:flex;">
                    <span style="font-size:10px;transform: translate(8px, -9px);position: absolute;width: 32px;text-align: center;color:rgba(255,255,255,1);backdrop-filter: blur(5px);">经度</span>
                    <div style="display:flex;align-items: center;width:100%;color:rgb(185, 185, 185);background: rgba(42 42 42);">
                        <div style="width:33%;display:flex;align-items: center;">
                            <input v-model="pointLon[0]" type="text" style="width:75%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);">度
                        </div>
                        <div style="width:33%;display:flex;align-items: center;">
                            <input v-model="pointLon[1]" type="text" style="width:75%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);">分
                        </div>
                        <div style="width:33%;display:flex;align-items: center;">
                            <input v-model="pointLon[2]" type="text" style="width:75%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);">秒
                        </div>
                    </div>
                </div>
            </div>
            <div style="width:43%;height:32px;display:flex;align-items: center;justify-content: center;margin-left:2px;">
                <div style="width:100%;height:100%;border:1px solid #a4a4a4;border-radius:6px;display:flex;">
                    <span style="font-size:10px;transform: translate(8px, -9px);position: absolute;width: 32px;text-align: center;color:rgba(255,255,255,1);backdrop-filter: blur(5px);">纬度</span>
                    <div style="display:flex;align-items: center;width:100%;color:rgb(185, 185, 185);background: rgba(42 42 42);">
                        <div style="width:33%;display:flex;align-items: center;">
                            <input v-model="pointLat[0]" type="text" style="width:75%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);">度
                        </div>
                        <div style="width:33%;display:flex;align-items: center;">
                            <input v-model="pointLat[1]" type="text" style="width:75%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);">分
                        </div>
                        <div style="width:33%;display:flex;align-items: center;">
                            <input v-model="pointLat[2]" type="text" style="width:75%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);">秒
                        </div>
                    </div>
                </div>
            </div>
            <!-- <a :class="`${/dashboard\/analysis/.test(pageHref)&&!$parent.allScreen?'homeBtnTenStyle':''}`" style="margin-left:10px;color:white;" v-if="pointUnit=='十进制'" @click="pointUnit='度分秒'"><a-icon type="swap" />十进制</a> -->
            <div title="切换成十进制" v-if="pointUnit=='十进制'" @click="pointUnit='度分秒'" class="sjzBtnDiv"><img src="~@/assets/RSsserviceManage/切换.png"></div>
            
        </div>

        <a-list :class="`searchList ${/dashboard\/analysis/.test(pageHref)&&!$parent.allScreen?'homeStyle':''}`" :loading="loading" item-layout="horizontal" :data-source="items" v-if="items.length>0">
          <div v-if="showLoadingMore" slot="loadMore"
            :style="{ textAlign: 'center', marginTop: '12px', height: '32px', lineHeight: '32px' }">
            <a-spin v-if="loadingMore" />
            <a-button v-else @click="onLoadMore">
              加载更多
            </a-button>
          </div>
          <a-list-item class="searchListItem" slot="renderItem" slot-scope="item">
              <div>
                <a @click="jumpTo(item.location,item.detail)">{{ item.name }}</a>
                <span>{{ item.detail }}</span>
              </div>
          </a-list-item>
        </a-list>
    </div>
</template>
<script>
import Axios from 'axios'
import coordtransform from 'coordtransform'
import { fromLonLat,toLonLat,transform } from 'ol/proj'
import {convertGPSToXY, convertXYToGPS, convertGPSToArray, convertArrayToGPS} from './convertGPSAndXY'

export default {
    name: 'SearchBar',
    data() {
      return {
        keyword:'',//输入的关键字
        latLng:[],//经纬度数组
        poiResult:[],//查询结果

        loading: false,
        loadingMore: false,
        showLoadingMore: false,

        pageHref:window.location.href,
        pointUnit:'度分秒',
        pointLon:['','',''],//度分秒的经度
        pointLat:['','',''],//度分秒的纬度
      }
    },
    mounted(){
    },
    methods:{
        search() {
            if (this.keyword != '') {
                // Axios.get("/searchapi/POI/search?name=" + this.keyword)
                // Axios.get("/accessapi/searchService/search?name=" + this.keyword)
                //     .then((res) => {
                //         this.poiResult = []
                //         res.data.result.forEach( (item) => {
                //             if(item.location){
                //                 let tmp = {
                //                     name: '',
                //                     detail: '',
                //                     location: ''
                //                 }
                //                 tmp.name = item.name
                //                 tmp.detail = item.city +  item.district
                //                 //百度经纬度坐标转国测局坐标
                //                 let bd09togcj02Result = coordtransform.bd09togcj02(item.location.lng, item.location.lat);
                //                 //国测局坐标转wgs84坐标
                //                 tmp.location = coordtransform.gcj02towgs84(bd09togcj02Result[0], bd09togcj02Result[1]);
                //                 // tmp.location =coordtransform.bd09towgs84(item.location.lat, item.location.lng);
                //                 this.poiResult.push(tmp)
                //             }
                //         })
                //         console.log(this.poiResult)
                //         // debugger
                //     })

                Axios.get("/koa_back/searchPOI?keyword=" + this.keyword)
                    .then((res) => {
                        this.poiResult = []
                        res.data.data.forEach( (item) => {
                            if(item.location){
                                let tmp = {
                                    name: '',
                                    detail: '',
                                    location: ''
                                }
                                tmp.name = item.title
                                tmp.detail = item.city + item.district
                                //国测局坐标转wgs84坐标
                                tmp.location = coordtransform.gcj02towgs84(item.location.lng, item.location.lat);
                                this.poiResult.push(tmp)
                            }
                        })
                        console.log(this.poiResult)
                    })
            }
        //   this.selected = false
        //   this.noSearch = false
        },
        jumpTo(location,detail){
            let p;//3857的坐标点
            if(/高德地图/.test(detail)) {
                p = coordtransform.gcj02towgs84(location[0], location[1]);
                p=fromLonLat(p);
            }else if(/百度地图/.test(detail)){
                //百度经纬度坐标转国测局坐标
                let bd09togcj02Result = coordtransform.bd09togcj02(location[0], location[1]);
                //国测局坐标转wgs84坐标
                p = coordtransform.gcj02towgs84(bd09togcj02Result[0], bd09togcj02Result[1]);
                p=fromLonLat(p);
            }else {//由于接口调用的百度，所以按地名查出来的点都是百度坐标系的，已经转换成wgs84坐标系了
                //这里location已经是wgs84坐标系的点了
                p=fromLonLat(location);
            }
            
            (this.$parent.jumpTo||this.$parent.$refs.mainmap.jumpTo)(p)
        },
        clear(){
            this.keyword = ''
            this.poiResult = []
            this.latLng = []
            let location=this.$parent.location||this.$parent.$refs.mainmap.location
            location.clear();
        },
    },
    computed:{
        items() {
            let tmp = []
            tmp = tmp.concat(this.latLng)
            tmp.push(...this.poiResult)
            return tmp
        }
    },
    watch:{
        keyword(){
            // console.log(this.keyword)
            this.keyword=this.keyword || '';
            this.keyword = this.keyword.replace(/，/g, ',')
            var t1 = /^-?[0-9]*\.?[0-9]*,|，.-?[0-9]*\.?[0-9]*$/
            this.latLng = []
            if(this.keyword.match(t1)!== null){
                let tmp = this.keyword.split(',')
                let tmp0 = parseFloat(tmp[0])
                let tmp1 = parseFloat(tmp[1])
                if(tmp.length === 2 && !isNaN(tmp1) && !isNaN(tmp0)){
                    if(tmp1>=-90 && tmp1<=90 && tmp0>=-180 && tmp0<=180) {
                        this.latLng.push({
                            name:'经度' + tmp0 + ', ' + '纬度' + tmp1,
                            detail: '经纬度来源：WGS84坐标系',
                            location: [ tmp0, tmp1]
                        })
                        this.latLng.push({
                            name:'经度' + tmp0 + ', ' + '纬度' + tmp1,
                            detail: '经纬度来源：百度地图',
                            location: [ tmp0, tmp1]
                        })
                        this.latLng.push({
                            name:'经度' + tmp0 + ', ' + '纬度' + tmp1,
                            detail: '经纬度来源：高德地图/谷歌地图',
                            location: [ tmp0, tmp1]
                        })
                    }
                    if(tmp1>=-180 && tmp1<=180 && tmp0>=-90 && tmp0<=90 && tmp1!=tmp0) {
                        this.latLng.push({
                            name: '纬度' + tmp0 + ', ' + '经度' + tmp1,
                            detail: '经纬度来源：WGS84坐标系',
                            location:  [tmp1, tmp0]
                        })
                        this.latLng.push({
                            name: '纬度' + tmp0 + ', ' + '经度' + tmp1,
                            detail: '经纬度来源：百度地图',
                            location:  [tmp1, tmp0]
                        })
                        this.latLng.push({
                            name: '纬度' + tmp0 + ', ' + '经度' + tmp1,
                            detail: '经纬度来源：高德地图/谷歌地图',
                            location:  [tmp1, tmp0]
                        })
                    }
                }
            }
            // console.log(this.latLng)

            if (this.keyword === null){this.keyword = ''}
            if (this.keyword === ''){
                this.targetResult = []
                this.poiResult = []
                this.clear();
            }
            this.search();
        },

        pointLon:{
            handler(newVal){
                let dfmLon=convertArrayToGPS(newVal);
                let lonStr=convertGPSToXY(dfmLon);
                let dfmLat=convertArrayToGPS(this.pointLat);
                let latStr=convertGPSToXY(dfmLat);
                this.keyword=lonStr+','+latStr;
            },
            deep:true
        },
        pointLat:{
            handler(newVal){
                let dfmLon=convertArrayToGPS(this.pointLon);
                let lonStr=convertGPSToXY(dfmLon);
                let dfmLat=convertArrayToGPS(newVal);
                let latStr=convertGPSToXY(dfmLat);
                this.keyword=lonStr+','+latStr;
            },
            deep:true
        },
        
    }
}
</script>
<style lang="scss" scoped>
    ::v-deep .ant-list-item{
        border-bottom: unset !important;
    }
    .dfmBtn{
        position: absolute;
        top: 18px;
        left: 210px;
        color: white;
    }
    .dfmBtnDiv{
        cursor: pointer;
        position: absolute;
        top: 25px;
        left: 235px;
        border: #a4a4a4 1px solid;
        border-radius: 4px;
        width: 30px;
        height: 30px;
        background-color: rgba(0,0,0,0.5);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .dfmAllDiv{
        position:absolute;
        display:flex;
        align-items:center;
        width:500px;
        z-index:999;
        top:25px;
        left: 25px;
    }
    .sjzBtnDiv{
        cursor: pointer;
        margin-left: 10px;
        border: #a4a4a4 1px solid;
        border-radius: 4px;
        width: 30px;
        height: 30px;
        background-color: rgba(0,0,0,0.5);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .searchBar{
        position: absolute;
        width: 200px;
        top: 25px;
        left: 25px;
        background: rgba(0,0,0,0.5);
    }
    .searchList{
        position: absolute;
        min-width: 200px;
        top: 65px;
        left: 25px;
    }
    // ::v-deep .ant-list-items{
    .searchListItem{
        background: rgba(0,0,0,0.5);
        div{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 5px;
            color:white;
            a{
                font-size:14px;
                color:white;
            }
            span{
                font-size:12px;
                margin-left:30px;
                color:rgb(185, 185, 185);
            }
        }
    }
    ::v-deep .ant-spin-container{
        background: unset;
    }
    ::v-deep .anticon,
    ::v-deep .ant-input-suffix,
    ::v-deep .ant-input-suffix:hover{
        color:rgb(185, 185, 185);
    }
    ::v-deep .ant-input-clear-icon:hover{
        color:rgb(255, 255, 255);
    }
    ::v-deep .ant-input{
        background: rgba(0,0,0,0.5);
        color:rgb(185, 185, 185);
    }
    ::v-deep .ant-input-clear-icon{
        color:rgb(185, 185, 185);
    }
    ::v-deep ul{
        padding-left:unset;
    }
    .homeStyle{
        left: 524px;
    }
    .homeBtnStyle{
        left: 730px;
    }
    .homeBtnTenStyle{
        left: 1030px;
    }
</style>